import apis from "../../core/apis.js";

class PaymentMethodResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.paymentMethod).get(options);
  }

  get(id) {
    return this.$resource(apis.paymentMethod + id).get();
  }

  search(search = "") {
    return this.$resource(apis.paymentMethod).get({ search });
  }

  post(item) {
    return this.$resource(apis.paymentMethod).save(item);
  }

  update(id, item) {
    return this.$resource(apis.paymentMethod + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default PaymentMethodResource;



// WEBPACK FOOTER //
// ./src/resources/paymentMethod/paymentMethod.resource.js